import { IEvaluateCategoryKeysWithAll, IPosNegKey, posNegHash } from "const";
import { FC } from "react";

type Props = {
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  current: IPosNegKey;
  currentCategory: IEvaluateCategoryKeysWithAll;
};
const PosNegSelector: FC<Props> = ({ onChange, current, currentCategory }) => (
  <div className="select mr-2">
    <select onChange={onChange} value={current}>
      {currentCategory === "all" ? (
        <option key="all" value="all">
          すべて
        </option>
      ) : (
        Object.keys(posNegHash).map((ek) => (
          <option key={ek} value={ek}>
            {posNegHash[ek as IPosNegKey]}
          </option>
        ))
      )}
    </select>
  </div>
);
export default PosNegSelector;
